import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { servicePost } from "../../helper/api";
import { persistor } from "../../redux/app/store";

// import LogoutModal from "../modals/LogoutModal";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import LogoutModal from "../Modals/LogoutModal";

const MenuDrawer = ({ onHide }) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("wealth_user"))?.data
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const goToAdminUser = () => {
    navigate("/");
    onHide();
  };

  const goToClientAccount = () => {
    navigate("/account");
    onHide();
  };

  const goToContractorAccount = () => {
    navigate("/contractoraccount");
    onHide();
  };

  const goToTransaction = () => {
    navigate("/transation");
    onHide();
  };

  const goToInvoices = () => {
    navigate("/invoice");
    onHide();
  };

  const goToCleanerPayment = () => {
    navigate("/cleaner-payment");
    onHide();
  };

  const goToCoupan = () => {
    navigate("/coupon");
    onHide();
  };

  const goToTwoFa = () => {
    if (
      (user?.enableOn == true || user?.enableOn == "true") &&
      (user?.twoFaRequest == "false" ||
        user?.twoFaRequest == false ||
        user?.twoFaRequest == null)
    ) {
      navigate("/disable-twofa");
      onHide();
    } else if (
      (user?.enableOn == false ||
        user?.enableOn == "false" ||
        user?.enableOn == null) &&
      (user?.twoFaRequest == true || user?.twoFaRequest == "true")
    ) {
      navigate("/disable-request");
      onHide();
    } else if (
      (user?.enableOn == false ||
        user?.enableOn == "false" ||
        user?.enableOn == null) &&
      (user?.twoFaRequest == false || user?.twoFaRequest == "false")
    ) {
      navigate("/enable-twofa");
      onHide();
    } else {
      navigate("/disable-twofa");
      onHide();
    }
  };

  const logoutHandler = () => {
    // localStorage.clear();
    // dispatch({ type: "RESET_STORE" });
    // persistor.purge();
    // onHide();
    // navigate("/login");
    // Open the logout modal first
    setShowLogoutModal(true);
  };

  return (
    <>
      <LogoutModal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
      />
      <div className="menu-drawer-main-wrapper">
        <div className="menu-drawer-header">
          <div className="menu-drawer-left">
            <div className="menu-header-profile">
              <img
                // onClick={goToAccount}
                src="./images/icons/sidebar-2.svg"
                alt="icon"
              />
            </div>

            <div className="menu-contractor-detail">
              <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip id={`tooltip-bottom`}>{user?.email}</Tooltip>}
              >
                <p> {user?.email} </p>
              </OverlayTrigger>
            </div>
          </div>
          <div className="menu-drawer-right">
            <img
              onClick={onHide}
              src="./images/icons/close-icon.svg"
              alt="icon"
            />
          </div>
        </div>
        <div className="menu-drawer-main-wrap">
          <div className="menu-drawer-tab-repeat" onClick={goToAdminUser}>
            <div className="menu-drawer-tab-wrap">
              <img src="./images/icons/admin-user-icon.png" alt="icon" />
              <p> Admin User</p>
            </div>
          </div>

          <div className="menu-drawer-tab-repeat" onClick={goToClientAccount}>
            <div className="menu-drawer-tab-wrap">
              <img src="./images/icons/admin-user-icon.png" alt="icon" />
              <p> Client Account </p>
            </div>
          </div>

          <div
            className="menu-drawer-tab-repeat"
            onClick={goToContractorAccount}
          >
            <div className="menu-drawer-tab-wrap">
              <img src="./images/icons/admin-user-icon.png" alt="icon" />
              <p> Contractor Account</p>
            </div>
          </div>

          <div className="menu-drawer-tab-repeat" onClick={goToTransaction}>
            <div className="menu-drawer-tab-wrap">
              <img src="./images/icons/transfer-icon.png" alt="icon" />
              <p> Transactions </p>
            </div>
          </div>

          <div className="menu-drawer-tab-repeat" onClick={goToInvoices}>
            <div className="menu-drawer-tab-wrap">
              <img src="./images/icons/invoice-icon.png" alt="icon" />
              <p> Invoices </p>
            </div>
          </div>

          <div className="menu-drawer-tab-repeat" onClick={goToCleanerPayment}>
            <div className="menu-drawer-tab-wrap">
              <img
                class="cleaner-payment-icon"
                src="./images/icons/payment-icon.svg"
                alt="icon"
              />
              <p> Cleaner Payment </p>
            </div>
          </div>

          <div className="menu-drawer-tab-repeat" onClick={goToCoupan}>
            <div className="menu-drawer-tab-wrap">
              <img
                class="cleaner-payment-icon"
                src="./images/icons/coupon.svg"
                alt="icon"
              />
              <p> Coupon </p>
            </div>
          </div>

          <div className="menu-drawer-tab-repeat" onClick={goToTwoFa}>
            <div className="menu-drawer-tab-wrap">
              <img src="./images/icons/auth-logo.png" alt="icon" />
              <p> 2 FA </p>
            </div>
          </div>

          <div
            className="menu-drawer-tab-repeat"
            onClick={() => logoutHandler()}
          >
            <div className="menu-drawer-tab-wrap">
              <img src="./assets/icons/menu-logout-icon.png" alt="icon" />
              <p> Logout </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuDrawer;
